import { FormEvent, FunctionComponent, useCallback } from 'react';
import Button from '../../../Button';
import Alert from '../../../Alert';
import styles from './styles.module.scss';
import { CheckSolidIcon } from '../../../Icons';

export type ManualProps = {
    message?: string;
    onConfirmed: () => unknown;
};

export const Manual: FunctionComponent<ManualProps> = ({ message, onConfirmed }) => {
    const onSubmit = useCallback(
        (event: FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            onConfirmed();
        },
        [onConfirmed]
    );

    return (
        <form onSubmit={onSubmit} className={styles.container}>
            <Alert preset="info">{message || 'Pay the organizer on the day.'}</Alert>
            <Button preset="primary">
                <CheckSolidIcon />
                Confirm Payment
            </Button>
        </form>
    );
};
